import type { SubscriptionBillingOption } from '@vista-digital/ocapi-types/v1'
import { getOrderSubscription, getSubscriptionBillingOptionById } from '@vista-digital/occ-domain'

export const getSelectedSubscriptionBillingOption: () => SubscriptionBillingOption | null = () => {
    const orderSubscription = getOrderSubscription()
    if (!orderSubscription) return null
    const subscriptionBillingOption = getSubscriptionBillingOptionById(orderSubscription.subscriptionBillingOptionId)
    if (!subscriptionBillingOption) return null
    return subscriptionBillingOption
}
